import moment from "moment";
import {
  Restaurant,
  RestaurantCart,
} from "../../../../../interfaces/Catalogue";
import { findCurrentShift } from "../../../../../utils/shopSubtittleFormat";
import {
  getOrderTypeText,
  MODE_DELIVERY,
} from "../../../../../constants/constants";
import "./CartHeader.scss";
import { useSelector } from "react-redux";
import { extractClientAddress } from "../../../../../utils/deliveryUtils";
interface CartHeaderProps {
  restaurantCart: RestaurantCart;
  restaurant: Restaurant;
}

export default function CartHeader(props: CartHeaderProps) {
  const { restaurant, restaurantCart } = props;
  const currentShift = findCurrentShift(restaurant);
  const orderTypeText = getOrderTypeText(restaurantCart?.mode);

  const deliveryAddress = useSelector(
    (state: any) => state.delivery.deliveryAddress,
  );

  const clientAddress = extractClientAddress(deliveryAddress || {});

  return (
    <div className="CartHeader">
      {props?.restaurantCart?.categories?.length === 0 ? (
        "No restaurantCart"
      ) : (
        <div>
          <div className="wrapper">
            <p className="restaurantName">
              {restaurant?.nom} - {restaurant?.address}
            </p>
            <p className="restaurant-status">
              {currentShift?.isCurrentShift ? "Fermé" : "Ouvre"} à{" "}
              {currentShift?.isCurrentShift
                ? moment(currentShift?.close, "HH:mm").format("HH:mm")
                : moment(currentShift?.open, "HH:mm").format("HH:mm")}{" "}
            </p>
            <div className="col-wrapper">
              <p className="restaurantAdresse">
                {orderTypeText}
                {restaurantCart?.mode === MODE_DELIVERY && clientAddress && (
                  <>
                    {" à : "}
                    {clientAddress.streetAddress}
                    {clientAddress.city && `, ${clientAddress.city}`}
                    {clientAddress.state && `, ${clientAddress.state}`}
                    {clientAddress.zip_code && ` ${clientAddress.zip_code}`}
                  </>
                )}
              </p>

              <p className="articlesSlot">
                {restaurantCart?.categories?.length} article
                {restaurantCart?.categories?.length > 1 ? "(s)" : ""}
              </p>
            </div>
          </div>
          <div className="seperator-cart"></div>
        </div>
      )}
    </div>
  );
}
